// export const BASE_URL = "https://oneapp-backend-preprod.abfldirect.com";
// export const BASE_URL = "https://wso2-apigw-uat.abfldirect.com/oneapp";
// export const BASE_URL = "https://oneapp-wso2.abfldirect.com/oneapp";
export const BASE_URL = "https://oneapp-wso2.abfldirect.com/oneapp";


// export const BASE_URL = "http://172.31.70.65:5533";

export const ERROR_LOGGING = "/logError";
export const ESB_DSA_SOURCE = "esb";
export const EPL_SOURCE = "epl";
export const UPSELL_SOURCE = "upsell";

export const GET_CUSTOMER_DETAILS = "/getCustomerDetailsEPL";

export const SEND_EMAIL_OTP = "/sendEmailOTP";
export const VERIFY_EMAIL_OTP = "/verifyEmailOtp";
export const SEND_OTP = "/sendOTP";
export const VERIFY_OTP = "/verifyOTP";
export const NEW_APPLICATION = "/createNewApplication";
export const INIT_UPSELL = "/initUpsellApp";
export const INIT_ESB = "/initEsbApp";

export const VERIFY_PAN = "/verifyPAN";
export const VERIFY_PAN_V2 = "/verifyPANV2";
export const SAVE_BASIC_DETAILS = "/saveBasicDetails";
export const CKYC_INIT = "/ckyc-init";
export const PINCODE_MASTER = "/checkServiceablepinCode";
export const BUREAU_CIBIL = "/bureauCall";
export const KARZA_CHECK = "/employmentCheck";
export const INCOME_CHECK = "/tiercheck";

export const GET_CONSTANTS = "/getConstants";
export const GET_ORG_NAME= "/getFilteredOrgs";
export const INSERT_PROFESSIONAL_DETAILS = "/insertProfessionalDetails";
export const INSERT_SELF_EMPLOYED_DETAILS = "/saveSelfEmployedDetails";
export const BEUREU_POLLING = "/bureauCheckStatus";
export const DS_PARSER = "/dsCallSync";
export const DS_PARSER_CHECK = "/dsCheckStatus";
export const call_UPSELL_CE = "/callCEUpsell";
export const GET_BANK_MASTER = "/perfios_institution_match";
export const AA_LINK = "/aa_wrapper";


export const GET_PERFIOS_LINK = "/perfios_generate_link";
export const PERFIOS_REPORT = "/perfios_retrieve_reports";
export const GET_TARTAN_LINK = "/digitalVerify";
export const TARTAN_POLLING = "/digitalVerifyPolling";

export const PERFIOS_TRANSACTION_STATUS = "/perfios_transaction_status";
export const TRIGGER_CE = "/trigger_ce";
export const CE_POLL = "/ce_polling";
export const AA_TRANSACTION_STATUS = "/aa_transactionstatus";

export const INSERT_IPO = "/insertIpoDetails";
export const REVIEW_IPO = "/reviewIpoDetails";

export const INSERT_SELFIE = "/insertSelfie";
export const LIVELINESS = "/liveliness";
export const CE_POLLING = "/checkCEStatus";

export const REFERENCE_DETAILS = "/referenceDetails";

export const INSERT_BANK_DETAILS = "/insertBankDetails";

export const CKYC_POLLING = "/ckyc-polling";
export const OKYC_POLLING = "/okycPolling";
export const OKYC_CREATE_PROFILE = "/okycCreateProfile";
export const CKYC_DATASCIENCE = "/ckyc-datascience";
export const OKYC_DATASCIENCE = "/okycDataScience";
export const NISHANDEH_GEOTAG = "/nishandeh_geotag";
export const FACEMACTH = "/faceMatch";
export const UPDATE_ADDRESS = "/updateAddressDetails";
export const ZUMIGO = "/zumigoGetDistanceV2";

export const EMANDATE = "/emandate";
export const EMANDATE_POLLING = "/checkEmandateStatus";
export const MANDATE_LINK = "/create_mandate_link";
export const MANDATE_STATUS = "/get_mandate_status";
export const GET_BRANCH = "/getIfscBranch";
export const PENNY_DROP = "/pennyDrop";
export const DS_NAME_MATCH = "/dsNameMatch";


export const GET_ALL_DOCS = "/getAllDocuments";
export const DIGISIGN = "/digitalSign";

export const UPDATE_DYNAMO_DB = "/updateDynamodb";
export const LMS_LOAN_DISBURSAL_A3S = "/lmsLoanDisbursalAsyncA3S";
export const LMS_LOAN_DISBURSAL_FINNONE = "/lmsLoanDisbursalAsyncFinnone";

export const VIDEO_KYC_CREATE_PROFILE = "/performVkyc";
export const VIDEO_KYC_FETCH_PROFILE = "/pollingVkyc";

export const MOVE_STAGE_BACK = "/move_stage_back";

export const GST_SEARCH = "/gst_search";
export const GST_GET_DETAILS = "/gst_get_details";
export const GST_RETURN_DETAILS = "/get_gst_return_details";
export const GST_VERIFY_DETAILS = "/gst_verify_details";

export const UDYAM_SEND_OTP = "/trigger_udyam_otp";
export const UDYAM_VERIFY = "/udyam_fetch";
export const UDYAM_DEROG_CHECK = "/udyam_derog_checks";

export const GET_DOCS = "/get_all_document";
export const UPLOAD_DOC = "/upload_document";

export const MOVE_TO_NSTP = "/moveToNSTP";
export const UPDATE_USER_CONSENT_STATUS = "/update_user_consentStatus";
